"use client";

import { useEffect } from "react";

/* Scroll fade-up with stagger (same behaviour as the Our People page), scoped to .responsible-page */
const groups = [".rb-section-heading", ".rb-card", ".rb-initiative"];

export default function RbReveal() {
  useEffect(() => {
    const root = document.querySelector(".responsible-page");
    if (!root) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rb-rv--in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    groups.forEach((selector) => {
      const perParent = new Map();
      root.querySelectorAll(selector).forEach((node) => {
        const index = perParent.get(node.parentElement) ?? 0;
        perParent.set(node.parentElement, index + 1);

        node.classList.add("rb-rv");
        node.style.setProperty("--rv-delay", `${(index % 6) * 80}ms`);
        io.observe(node);
      });
    });

    return () => io.disconnect();
  }, []);

  return null;
}
